// React
import React from "react";
// Framework
import { usePortal } from "stack/core";
import { useStackDependency } from "stack/dependency";

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const PWAProvider = ({ children }) => {
  // Framework
  const { pwa } = usePortal();
  // Init
  useStackDependency(pwa);
  // Render
  return <>{children}</>;
};

export { PWAProvider };
